import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  if (config.data instanceof FormData) delete config.headers['Content-Type'];
  }
  
  // Add company header
  const currentCompany = localStorage.getItem('currentCompany');
  if (currentCompany) {
    try {
      const company = JSON.parse(currentCompany);
      if (company?.id) {
        config.headers['X-Company-ID'] = company.id;
      }
    } catch (e) {}
  }
  
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentCompany');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');
export const getDashboardCharts = () => api.get('/dashboard/charts');
export const getRecentActivities = () => api.get('/dashboard/recent-activities');

// Seed
export const seedDatabase = () => api.post('/seed');

// Companies
export const companiesAPI = {
  getAll: () => api.get('/companies'),
  getById: (id) => api.get(`/companies/${id}`),
  create: (data) => api.post('/companies', data),
  update: (id, data) => api.put(`/companies/${id}`, data),
  delete: (id) => api.delete(`/companies/${id}`),
};

// Roles
export const rolesAPI = {
  getAll: () => api.get('/roles'),
  getTemplates: () => api.get('/roles/templates'),
  create: (data) => api.post('/roles', data),
  update: (id, data) => api.put(`/roles/${id}`, data),
  delete: (id) => api.delete(`/roles/${id}`),
};

// Users
export const usersAPI = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  assignCompany: (userId, data) => api.post(`/users/${userId}/assign-company`, data),
  removeFromCompany: (userId, companyId) => api.delete(`/users/${userId}/company/${companyId}`),
};

// Generic CRUD
const createCRUD = (endpoint) => ({
  getAll: () => api.get(`/${endpoint}`),
  getById: (id) => api.get(`/${endpoint}/${id}`),
  create: (data) => api.post(`/${endpoint}`, data),
  update: (id, data) => api.put(`/${endpoint}/${id}`, data),
  delete: (id) => api.delete(`/${endpoint}/${id}`),
});

// CRM
export const clientsAPI = createCRUD('clients');
export const contactsAPI = createCRUD('contacts');
export const leadsAPI = createCRUD('leads');
export const dealsAPI = createCRUD('deals');

// Sales
export const quotationsAPI = createCRUD('quotations');
export const salesOrdersAPI = createCRUD('sales-orders');

// Procurement
export const suppliersAPI = createCRUD('suppliers');
export const productsAPI = createCRUD('products');
export const purchaseOrdersAPI = createCRUD('purchase-orders');
export const billsAPI = createCRUD('bills');
export const paymentsAPI = createCRUD('payments');

// Projects
export const projectsAPI = createCRUD('projects');
export const tasksAPI = createCRUD('tasks');
export const ticketsAPI = createCRUD('tickets');
export const sitesAPI = createCRUD('sites');

// Inventory
export const warehousesAPI = createCRUD('warehouses');
export const stockMovementsAPI = createCRUD('stock-movements');

// Finance
export const invoicesAPI = createCRUD('invoices');
export const expensesAPI = createCRUD('expenses');
export const accountsAPI = createCRUD('accounts');
export const journalEntriesAPI = createCRUD('journal-entries');

// HR
export const employeesAPI = createCRUD('employees');
export const departmentsAPI = createCRUD('departments');
export const attendanceAPI = createCRUD('attendance');
export const payrollAPI = createCRUD('payroll');
export const leavesAPI = createCRUD('leaves');

// Other
export const documentsAPI = createCRUD('documents');
export const currenciesAPI = createCRUD('currencies');
export const posTransactionsAPI = createCRUD('pos-transactions');

export default api;
